/** Flat to-do item node with expandable and level information */
export class TodoItemFlatNode {
  descricao: string;
  id: number;
  tipo: number;
  idPai: number;
  level: number;
  expandable: boolean;
  jaTemAcesso?: boolean;
}
